import { render } from "./NavbarSubmenuItem.vue?vue&type=template&id=6dfd5925"
import script from "./NavbarSubmenuItem.vue?vue&type=script&lang=js"
export * from "./NavbarSubmenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__